import { __ } from '../../../i18n';

export function panes() {
  return [
    { menuItem: __('Revenue'), value: 'payments' },
    { menuItem: __('Charges'), value: 'charges' },
    { menuItem: __('Accounts and Withdrawals'), value: 'accounts' },
  ];
}
